import React, { Component } from "react";
import Modal from 'react-modal';
import { Link } from "react-router-dom";
import ButtonWithIcon from "./ButtonWithIcon";

Modal.setAppElement('#root');

export default class SecondaryInfoPopup extends Component {
  render() {
    const { show, close, missingFields, user } = this.props;

    const customStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        padding: '20px',
        borderRadius: '8px',
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
    };

    if (!show) return null;

    return (
      <Modal
        isOpen={show}
        onRequestClose={close}
        style={customStyles}
        shouldCloseOnOverlayClick={false}
        contentLabel="Update Billing Contact Details"
      >
        <h2 style={{ marginBottom: '20px', fontSize: '20px', textAlign: 'center' }}>
          Update Billing Contact Details
        </h2>
        <p style={{ marginBottom: '20px', textAlign: 'center' }}>
          Please update your billing contact details to complete your profile setup.
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
          <ButtonWithIcon isBtnActive text={"Update Now"} linkData={{
            pathname: '/profile-settings', state: { user: user }
          }} />
          <ButtonWithIcon text={"Skip"} onClick={close} />
        </div>
      </Modal>
    );
  }
}
